<template>
  <div class="app-main-content">
    <share-list price-sharing="PriceAirSharing" />
  </div>
</template>

<script>
import ShareList from '@/views/cargo/v0/Price/components/list/ShareList'
export default {
  name: 'PriceAirShare',
  components: { ShareList }
}
</script>

<style scoped>

</style>
